export default {
  namespaced: true,
  state: {
    items: [],
  },
  actions: {
    setCurrentRoute({ commit }, value) {
      commit('setCurrentRoute', value);
    },
    pushRoute({ commit }, value) {
      commit('pushRoute', value);
    },
    replaceCurrent({ commit }, value) {
      commit('replaceCurrent', value);
    },
    popRoute({ commit }) {
      commit('popRoute');
    },
    clearRoutes({ commit }) {
      commit('setCurrentRoute', []);
    },
  },
  mutations: {
    setCurrentRoute(state, value) {
      state.items = [];
      state.items = value;
    },
    pushRoute(state, value) {
      this.commit('breadcrumb/clearActives');

      state.items.push(value);
    },
    replaceCurrent(state, value) {
      this.commit('breadcrumb/clearActives');

      state.items[state.items.length - 1] = value;
    },
    clearActives(state, value) {
      state.items = state.items.map((item) => {
        if (item.active) {
          item.active = false;
        }
        return {
          ...item,
        };
      });
    },
    popRoute(state) {
      state.items.pop();
    },
  },
};
